module.exports = __webpack_public_path__ + "static/media/trash.155cb9ec.svg";